import { Component, OnInit, Input, HostBinding, Optional, ViewChild } from '@angular/core';
import { AssigneeInfo, AssigneeInfoByProcInstIdParameter } from '../../entity/complete-response';
import { UserService } from '../../runtime/services/user.service';
import { Observable, Subject } from 'rxjs';
import { NotifyService } from '@farris/ui-notify';
import { TaskService } from '../../runtime/services/task.service';
import { I18nService } from '../../runtime/services/i18n.service';
import { DataTableComponent } from '@farris/ui-datatable';
import { PaginationInstance } from '@farris/ui-pagination';
import { LoadingService } from '@farris/ui-loading'

@Component({
  selector: 'wf-assign-participant',
  templateUrl: './assign-participant.component.html',
  styleUrls: ['./assign-participant.component.css']
})
export class AssignParticipantComponent implements OnInit {
  @HostBinding('class')
  cls = 'farris-main-area flex-column';

  private pageList = [10, 20, 30, 50, 100];
  paginationOptions: PaginationInstance = {
    id: 'WF-Users-DataTable-Pagination',
    currentPage: 1,
    itemsPerPage: 10,
    pageList: this.pageList,
    totalItems: 0
  };

  @Input()
  set assigneeInfo(assigneeInfos: AssigneeInfo[]) {
    this.assignees = assigneeInfos;
    this.assigneesPa = {
      procInstId: '',//后端用不到 先为空
      assigneeInfos: []
    };
    this.getUserList();
  }

  private assignees: AssigneeInfo[];
  private assigneesPa: AssigneeInfoByProcInstIdParameter;
  private allowGlobalAssign: boolean;
  private subject = new Subject<AssigneeInfoByProcInstIdParameter>();
  private withAllOrg: boolean = true;
  private orgId: string = '';
  userListData = [];
  // 是否允许多选,默认多选
  singleSelect = false;
  searchValue = null;
  selectedUsers: {
    ID: string,
    Code: string,
    Name: string,
    OrgId: string,
    OrgName: string
  }[] = [];
  @ViewChild('allUserTable') userTable: DataTableComponent;
  columns = [
    { title: this.i18nService ? this.i18nService.getValue('static.columnName.code') : '编号', field: 'Code', width: 80 },
    { title: this.i18nService ? this.i18nService.getValue('static.columnName.name') : '姓名', field: 'Name', width: 90 },
    { title: this.i18nService ? this.i18nService.getValue('static.columnName.department') : '组织信息', field: 'OrgName', width: 180 }];
  constructor(
    protected userSvc: UserService,
    protected notify: NotifyService,
    private taskSvc: TaskService,
    private loadingService: LoadingService,
    @Optional() protected i18nService: I18nService
  ) {
  }

  ngOnInit() {
  }

  getUserList() {
    this.singleSelect = !this.assignees[0].multiSelect;
    if (this.assignees[0].assigneeUsers && this.assignees[0].assigneeUsers.length) {
      this.getAssignedUsers();
    } else {
      if (this.assignees[0].allowGlobalAssign) {
        if (this.assignees[0].organizationScope && this.assignees[0].organizationScope.length) {
          this.withAllOrg = this.assignees[0].organizationScope[0].includeChildren;
          this.orgId = this.assignees[0].organizationScope[0].id;
        }
        this.getAllUserList();
      } else {
        this.getAssignedUsers();
      }
    }
  }

  getAssignedUsers() {
    if (this.assignees.length > 0) {
      this.selectedUsers = this.assignees[0].assigneeUsers.map(user => {
        return {
          ID: user.id,
          Name: user.name,
          Code: user.code,
          OrgId: user.orgId,
          OrgName: user.orgNamePath
        };
      }),
        this.userListData = this.selectedUsers;
    }
  }

  protected getAllUserList() {
    const load = this.loadingService.show();
    this.userSvc.getUserList_Assign(this.searchValue, this.paginationOptions.currentPage, this.paginationOptions.itemsPerPage, this.withAllOrg, this.orgId)
      .subscribe((re: { totalCount: number, data: any[] }) => {
        load.close();
        this.paginationOptions.totalItems = re.totalCount;
        this.userListData = re.data.map(u => ({
          ID: u.id,
          Code: u.code,
          Name: u.name,
          OrgId: u.sysOrgId,
          OrgName: u.orgNamePath,
          Checked: false
        }));
      }, error => {
        load.close();
      });
  }

  search(event) {
    this.searchValue = event.value;
    if (this.assignees[0].assigneeUsers && this.assignees[0].assigneeUsers.length) {//有候选人，在候选人中筛选
      if(this.searchValue) {
        this.userListData = this.selectedUsers.filter(user =>
          (user.Name) && user.Name.includes(this.searchValue) ||
          (user.Code) && user.Code.includes(this.searchValue)
        );
      } else {
        this.getAssignedUsers();
      }
    } else {//无候选人，在全员中选择
      this.paginationOptions.currentPage = 1;
      this.getUserList();
    }
  }

  btnCancelClick() {
    this.notify.info(this.i18nService ? this.i18nService.getValue('static.assignee.cancelAssign') : '已取消操作。');
    this.subject.next(null);
  }
  btnOKClick() {
    this.selectedUsers = this.singleSelect ? [this.userTable.selections] : this.userTable.selections;

    if (!this.selectedUsers || this.selectedUsers.length < 1) {
      this.notify.warning(this.i18nService ? this.i18nService.getValue('static.assignee.noAssignee') : '请至少选择一个审批人。');
      return;
    }

    // 添加已选人员
    const assigneeInfo = this.assignees.shift();
    assigneeInfo.assigneeIds = this.selectedUsers.map(user => user.ID);
    this.assigneesPa.assigneeInfos.push(assigneeInfo);

    // 检查指定是否完成，如果完成提交，否则继续指派任务
    if (this.assignees.length > 0) {
      this.userListData = []; // clear source
      this.getUserList();
    } else {
      const load = this.loadingService.show();
      this.taskSvc.assignNextUsersByProcInstId(this.assigneesPa).subscribe(() => {
        load.close();
        this.notify.success(this.i18nService ? this.i18nService.getValue('static.assignee.successAssign') : '操作成功。');
        this.subject.next(this.assigneesPa);
      }, err => {
        this.notify.error(this.i18nService ? this.i18nService.getValue('static.assignee.errorAssign') : '操作失败，请联系管理员查看原因！');
        this.subject.error(this.i18nService ? this.i18nService.getValue('static.assignee.errorAssign') : '操作失败，请联系管理员查看原因！');
      });
    }
  }
  subscribe(): Observable<AssigneeInfoByProcInstIdParameter> {
    return this.subject.asObservable();
  }

  onPageSizeChange(pageSize) {
    this.paginationOptions.itemsPerPage = pageSize;
    this.getUserList();
  }

  onPageChange(event) {
    this.paginationOptions.currentPage = event.pageIndex;
    this.getUserList();
  }

}
